import React, { useState, useEffect } from 'react';
import { useTelegram } from './TelegramProvider';
import { useTon } from './TelegramTonProvider';

export const TelegramWalletConnect = () => {
    const { hapticFeedback } = useTelegram();
    const { wallet, connected, isConnecting, connect, disconnect, formatAddress } = useTon();

    const handleConnect = async () => {
        try {
            console.log('🔄 TelegramWalletConnect: Нажата кнопка подключения кошелька');
            console.log('📊 Текущее состояние:', { connected, wallet, isConnecting });
            
            if (hapticFeedback) {
                hapticFeedback('light');
                console.log('📳 Haptic feedback отправлен');
            }
            
            console.log('🚀 Вызываем connect()...');
            const result = await connect();
            console.log('✅ Connect завершен с результатом:', result);
        } catch (error) {
            console.error('❌ Ошибка в handleConnect:', error);
        }
    };

    const handleDisconnect = () => {
        try {
            console.log('🔄 Нажата кнопка отключения кошелька');
            hapticFeedback('medium');
            disconnect();
        } catch (error) {
            console.error('❌ Ошибка в handleDisconnect:', error);
        }
    };


    if (connected && wallet) {
        return (
            <button className="wallet-connected-chip" onClick={handleDisconnect} title="Нажмите чтобы отключить">
                <span className="dot"></span>
                <span className="wallet-addr">
                    {formatAddress(wallet.account?.address || wallet.address)}
                </span>
            </button>
        );
    }

    return (
        <button
            className="wallet-connect-btn"
            onClick={handleConnect}
            disabled={isConnecting}
        >
            {isConnecting ? (
                <>
                    <span className="dot"></span>
                    Connecting…
                </>
            ) : (
                <>
                    <span className="dot"></span>
                    💎 Wallet
                </>
            )}
        </button>
    );
};
